// LW's default palette. Custom Material colours and contrast remain available.
export const LILITH_ACCENT = "#FF9700";
export const lilithPalette = {
  dark: {
    primary: "#FFAD38",
    "on-primary": "#251706",
    "primary-container": "#FF9700",
    "on-primary-container": "#241705",
    secondary: "#D7C9B7",
    "on-secondary": "#342C21",
    "secondary-container": "#352E26",
    "on-secondary-container": "#F0E5D8",
    tertiary: "#D8CBBB",
    "on-tertiary": "#322B23",
    "tertiary-container": "#3C3327",
    "on-tertiary-container": "#F3E3CC",
    surface: "#10121B",
    "surface-dim": "#0B0D14",
    "surface-bright": "#383A43",
    "surface-container-lowest": "#0B0D14",
    "surface-container-low": "#181B25",
    "surface-container": "#20232E",
    "surface-container-high": "#292D39",
    "surface-container-highest": "#343846",
    "on-surface": "#F7F4EF",
    "on-surface-variant": "#BEBEC6",
    outline: "#9293A0",
    "outline-variant": "#41434F",
    error: "#F0AAA2",
    "on-error": "#471C18",
    "error-container": "#442B28",
    "on-error-container": "#FFDAD4",
    "inverse-surface": "#F4F0E8",
    "inverse-on-surface": "#29251F",
    "inverse-primary": "#8A4B00",
  },
  light: {
    primary: "#8A4B00",
    "on-primary": "#FFFFFF",
    "primary-container": "#FF9700",
    "on-primary-container": "#241705",
    secondary: "#665A49",
    "on-secondary": "#FFFFFF",
    "secondary-container": "#EAE4D9",
    "on-secondary-container": "#433A2D",
    tertiary: "#685B46",
    "on-tertiary": "#FFFFFF",
    "tertiary-container": "#EEE4D3",
    "on-tertiary-container": "#4B3B24",
    surface: "#F7F5F0",
    "surface-dim": "#E3DED5",
    "surface-bright": "#FFFDF9",
    "surface-container-lowest": "#FFFFFF",
    "surface-container-low": "#F0ECE4",
    "surface-container": "#ECE7DE",
    "surface-container-high": "#E7E0D5",
    "surface-container-highest": "#E0D8CA",
    "on-surface": "#25221D",
    "on-surface-variant": "#6A6155",
    outline: "#8D8170",
    "outline-variant": "#D9D0C2",
    error: "#A44136",
    "on-error": "#FFFFFF",
    "error-container": "#FAE5DF",
    "on-error-container": "#6D3029",
    "inverse-surface": "#302A22",
    "inverse-on-surface": "#F5F0E7",
    "inverse-primary": "#FFAD38",
  },
};
